import type { ButtonProps } from "antd";
import { Button } from "antd";
import { ReactNode } from "react";

import "./style.scss";
const CustomButton = (
  props: ButtonProps & { children: string | ReactNode }
) => {
  // eg.
  // <CustomButton type="primary" htmlType="submit"></CustomButton>
  // <CustomButton type="default"></CustomButton>
  // <CustomButton type="primary" danger></CustomButton>
  return (
    <Button {...props} className="esim-custom-button">
      {props.children}
    </Button>
  );
};

export default CustomButton;
